import React, { useEffect, useState } from "react";
import { FlaskConical, X, RotateCcw } from "lucide-react";
import { activateTest, isTestMode, setTestKey, DEMO_SESSION } from "@/lib/testmode";

const seedDemoLocal = (data) => {
    localStorage.setItem("revanche_session_id", DEMO_SESSION);
    if (data?.demo_answers) localStorage.setItem("revanche_answers", JSON.stringify(data.demo_answers));
    if (data?.demo_analysis) localStorage.setItem("revanche_analysis", JSON.stringify(data.demo_analysis));
};

// Écrans du parcours -> destination. L'étape compte est l'index 5 du questionnaire.
const SCREENS = [
    ["Intro", "/", { step: 0 }],
    ["Questionnaire", "/analyse", { step: 0 }],
    ["Étape compte", "/analyse", { step: 5 }],
    ["Scan", "/photo", {}],
    ["Chargement", "/analyse-en-cours", {}],
    ["Teasing", "/teasing", {}],
    ["Aperçu", "/apercu", {}],
    ["Révélation", "/solution", {}],
    ["Mike", "/coach", {}],
    ["Compte", "/compte", {}],
    ["Résiliation", "/compte?retention=1", {}],
    ["Back-office", "/admin", { demo: false }],
];

const TestModeOverlay = () => {
    const [active, setActive] = useState(isTestMode());
    const [demo, setDemo] = useState(null);
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const key = params.get("test");
        if (key) {
            activateTest(key)
                .then((d) => {
                    setTestKey(key);
                    setDemo(d);
                    setActive(true);
                    params.delete("test");
                    const qs = params.toString();
                    window.history.replaceState({}, "", window.location.pathname + (qs ? `?${qs}` : ""));
                })
                .catch(() => {});
        } else if (isTestMode()) {
            activateTest(localStorage.getItem("revanche_test_key")).then(setDemo).catch(() => {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!active) return null;

    const go = (path, opts = {}) => {
        if (opts.demo !== false) seedDemoLocal(demo);
        if (opts.step != null) localStorage.setItem("revanche_step", String(opts.step));
        window.location.href = path;
    };

    const reset = () => {
        ["revanche_session_id", "revanche_answers", "revanche_analysis", "revanche_step", "revanche_rescan", "revanche_first_report_dl", "revanche_ref_popup_last"]
            .forEach((k) => localStorage.removeItem(k));
        window.location.href = "/";
    };

    if (!open) {
        return (
            <button data-testid="test-mode-badge" onClick={() => setOpen(true)}
                className="fixed left-2 bottom-2 z-[10000] flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-revred text-white shadow-lg"
                style={{ fontFamily: "'Archivo', sans-serif" }}>
                <FlaskConical size={13} />
                <span className="text-[11px] font-bold tracking-wide">MODE TEST</span>
            </button>
        );
    }

    return (
        <div data-testid="test-mode-bar"
            className="fixed inset-x-0 bottom-0 z-[10000] bg-black border-t-2 border-revred"
            style={{ paddingBottom: "max(6px, env(safe-area-inset-bottom))" }}>
            <div className="flex items-center gap-2 px-2 pt-1.5 pb-1">
                <span className="flex items-center gap-1 text-revred shrink-0" style={{ fontFamily: "'Archivo', sans-serif" }}>
                    <FlaskConical size={12} />
                    <span className="text-[10px] font-bold">TEST</span>
                </span>
                <span className="text-[10px] text-revtext-secondary shrink-0">Alex</span>
                <button data-testid="test-mode-hide" onClick={() => setOpen(false)} className="ml-auto text-white shrink-0"><X size={16} /></button>
            </div>
            <div className="flex gap-2 overflow-x-auto scrollbar-none px-2 pb-2">
                {SCREENS.map(([label, path, opts]) => (
                    <button key={label} data-testid={`test-go-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
                        onClick={() => go(path, opts)}
                        className="tap-feedback shrink-0 px-3 py-2 rounded-lg border border-ink-700 bg-ink-900 text-white text-xs whitespace-nowrap active:border-revred">
                        {label}
                    </button>
                ))}
                <button data-testid="test-reset" onClick={reset}
                    className="tap-feedback shrink-0 px-3 py-2 rounded-lg border border-revred text-revred font-bold text-xs whitespace-nowrap flex items-center gap-1.5">
                    <RotateCcw size={13} /> Réinitialiser
                </button>
            </div>
        </div>
    );
};

export default TestModeOverlay;
